import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import TargetAudience from "@/components/TargetAudience";
import Portfolio from "@/components/Portfolio";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-luxe-black text-white">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <TargetAudience />
      <Portfolio />
      <Contact />
      <Footer />
    </main>
  );
}
